module.exports = __webpack_public_path__ + "img/cases-brand-avic-lazyload-1319.90d73b84.jpg";